import React from "react";
import Header from "../../Components/layouts/Header";

const Calendar = () => {
  return (
    <>
      <Header title="Crop Advisary" subtitle="Calendar" />
      <section className="p-[1%]">
        <div className="grid grid-cols-[30%_30%_30%_10%] m">
          <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
            <label className="text-[#13490A] text-center">Type</label>
            <input
              type="text"
              className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
            />
            <img src="Images/Dropdown.png" className="px-4" />
          </div>
          <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
            <label className="text-[#13490A] text-center">Crop</label>
            <input
              type="text"
              className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
            />
            <img src="Images/Dropdown.png" className="px-4" />
          </div>
          <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
            <label className="text-[#13490A] text-center">Variety</label>
            <input
              type="text"
              className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
            />
            <img src="Images/Dropdown.png" className="px-4" />
          </div>
          <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
            Go
          </button>
        </div>
        <div className="my-5">
          <div className="overflow-hidden rounded-full border border-[#13490A]">
            <div className="h-2 w-1/2 rounded-full bg-[#13490A]"></div>
          </div>
          <ol className="mt-4 grid grid-cols-5 justify-between text-sm font-medium text-gray-500">
            <li className="text-blue-600 w-fit">
              <span className="hidden sm:inline text-[#13490A] font-bold">
                {" "}
                Basal(at Sowing){" "}
              </span>
            </li>
            <li className=" text-blue-600 justify-self-center w-fit">
              <span className="hidden sm:inline text-[#13490A] font-bold">
                {" "}
                V4(four leaf stage){" "}
              </span>
            </li>
            <li className=" text-blue-600 justify-self-center w-fit">
              <span className="hidden sm:inline text-[#13490A] font-bold">
                {" "}
                V8(eight leaf stage){" "}
              </span>
            </li>
            <li className=" text-blue-600 justify-self-center w-fit">
              <span className="hidden sm:inline text-[#13490A] font-bold">
                {" "}
                VT(tasseling stage){" "}
              </span>
            </li>
            <li className=" text-blue-600 justify-self-end w-fit">
              <span className="hidden sm:inline text-[#13490A] font-bold">
                {" "}
                GF(grain filling stage){" "}
              </span>
            </li>
          </ol>
        </div>
        <div className="text-[#13490A] font-extrabold">
          <h2 className="text-center">Young seedlings, knee high stage</h2>
          <div className="flex my-[2%] pl-[4%]">
            <p className="flex-[1]">Nutritional Activity :</p>
            <p className="flex-[4]">Nitrogen Rate(%) - 30</p>
          </div>
          <div className="flex my-[2%] pl-[4%]">
            <p className="flex-[1]">Water Management :</p>
            <p className="flex-[4]">
              Irrigation should be applied in furrows up to 2/3 rd height of
              ridges and beds.
            </p>
          </div>
          <div className="flex my-[2%] pl-[4%]">
            <p className="flex-[1]">Field Monitor :</p>
            <p className="flex-[4]">Look for Nutrition Deficiency</p>
          </div>
        </div>
        <div className="grid grid-cols-[20%_20%_20%_20%] justify-center items-center gap-x-[4%] w-full">
          <div className="h-full">
            <img src="Images/NitrogenDef1.png" alt="NitrogenDeficiency" className="h-[80%] w-full" />
            <p className="text-[#13490A] flex justify-center items-center font-extrabold h-[20%]">Nitrogen Deficiency</p>
          </div>
          <div className="h-full">
            <img src="Images/PhosporousDef1.png" alt="PhosporousDeficiency" className="h-[80%] w-full" />
            <p className="text-[#13490A] flex justify-center items-center font-extrabold h-[20%]">Phosphorus Deficiency</p>
          </div>
          <div className="h-full">
            <img src="Images/Potassium1.png" alt="Potassium" className="h-[80%] w-full" />
            <p className="text-[#13490A] flex justify-center items-center font-extrabold h-[20%]">Potassium Deficiency</p>
          </div>
          <div className="h-full">
            <img src="Images/zinc 1.png" alt="zinc" className="h-[80%] w-full" />
            <p className="text-[#13490A] flex justify-center items-center font-extrabold h-[20%]">Zinc Deficiency</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Calendar;
